<div class="inline-flex">
  <p-button
    [text]="true"
    appPrimengButton>
    <app-icon
      [icon]="Icon.Bell"
      class="text-xl" />
  </p-button>

  @if (count | toString; as count) {
    @if (isNotNil(count)) {
      <span
        [value]="count"
        pBadge
        severity="danger">
      </span>
    }
  }
</div>
